
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[restaurantId]/menu",
      function () {
        return require("private-next-pages/[restaurantId]/menu.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[restaurantId]/menu"])
      });
    }
  